<template>
  <el-dialog :title="$t('base.viewDetails')" :custom-class="dialogBox" :visible.sync="dislogType.warehouse" :lock-scroll="false" top='6.5vh'>
    <el-scrollbar v-loading.fullscreen="loading">
      <div id="dialogBoxWare">
        <div class="" v-if="dialogList" style="overflow: hidden;padding-bottom: 19px;">
          <div class="qwq" >
            <div>
              <h3 class="steps_h3" v-if="!isExp">{{ $t('alert.youItemInformation') }}</h3>
              <h3 class="steps_h3" v-if="isExp">{{expList.State>=3?$t('alert.youItemDelivered'):$t('alert.youItemTransit') }}</h3>
              <div class="steps_box">
                <div>
                  <div class="dot first " :class="expList.State?'greed':''">
                    <span class="yes el-icon-check"></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <div class="steps_txt first">
                    {{ $t('base.shipped') }}<br>{{setTimeSS(expList.ldate)}}
                  </div>
                </div>
                <div>
                  <div class="dot" :class="expList.State>=2?'greed':''">
                    <span></span>
                    <span></span>
                    <span class="yes el-icon-check"></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <div class="steps_txt">
                    {{ $t('base.inTransit') }}
                  </div>
                </div>
                <div>
                  <div class="dot" :class="expList.State>=3?'greed':''">
                    <span></span>
                    <span></span>
                    <span class="yes el-icon-check"></span>
                  </div>
                  <div class="steps_txt">
                    {{ $t('base.delivered') }}<br>{{setTimeSS(expList.ndate)}}
                  </div>
                </div>
              </div>
              <div class="steps_title" v-if="expList.Traces&&expList.Traces.length>0">{{dialogList.SecondExpressCode?dialogList.SecondExpressCode:dialogList.ExpressCode}}<span class="text_blue" v-if="dialogList.Express">#{{dialogList.SecondExpressCode?dialogList.SecondExpress:dialogList.Express}}</span> <span class="copy" @click="CopyLink(dialogList.SecondExpressCode?dialogList.SecondExpress:dialogList.Express)" v-if="dialogList.Express">{{$t('base.copy')}}</span></div>
            </div>
          </div>
          <el-scrollbar class="detail_steps" v-if="expList.Traces&&expList.Traces.length>0">
            <div class="steps_list" v-for="(item,index) in expList.Traces" :key="index" v-if="expList.Traces&&expList.Traces.length>0">
              <div class="steps_list_up">
                <span class="time">{{setTimeSS(item.AcceptTime)}}</span>
                <span class="dott"></span>
                <span class="add">{{item.AcceptStation}}</span>
              </div>
              <div class="steps_line"></div>
            </div>
            <div class="steps_list error" v-if="expList.Traces&&expList.Traces.length<=0">
              <div>{{$t('base.NoLogistics')}}</div>
            </div>
          </el-scrollbar>
          <div class="more " v-if="!isData" @click="isData=true">{{$t('base.more')}}<span class="el-icon-arrow-down"></span></div>
        </div>
        <div class="dialogData" v-if="dialogList&&isData">
          <ul class="detailPadding detailPaddingUL">
            <li v-if='dialogList.IsPay'>
              <span>{{$t('colon.paymentTime')}}</span>
              <span>{{setTime(dialogList.PayDate)}}</span>
            </li>
            <li v-if='dialogList.IsPay'>
              <span>{{$t('colon.paymentMethod')}}</span>
              <span>{{dialogList.PayType}}</span>
            </li>
            <li v-if='dialogList.IsSend&&(dialogList.ExpressName!=null||dialogList.Express!=null)'>
              <span>{{$t('colon.shipmentInfo')}}</span>
              <span v-if="dialogList.SecondExpressCode">{{dialogList.SecondExpressCode+' #'+dialogList.SecondExpress}}</span>
              <span v-else>{{dialogList.ExpressName+' #'+dialogList.Express}}</span>
            </li>
            <li v-if='dialogList.IsSend'>
              <span>{{$t('colon.shippingTime')}}</span>
              <span>{{setTime(dialogList.SendDate)}}</span>
            </li>
            <li>
              <span>{{ $t('colon.internationalShippingFee') }}</span>
              <span>{{areaSymbol}} {{dialogList.RealPostageMoney}}</span>
            </li>
            <li>
              <span>{{$t('colon.shippingFeePaid')}}</span>
              <span>{{dialogList.RealPayPostageMoney && dialogList.RealPayPostageMoney>0 ? areaSymbol+' '+dialogList.RealPayPostageMoney:'/'}}</span>
            </li>
            <li v-if="dialogList.Address">
              <span>{{$t('colon.userName')}} </span>
              <span>{{dialogList.Address.Consignee}}</span>
            </li>
            <li v-if="dialogList.Address">
              <span>{{$t('colon.address')}}</span>
              <span>{{dialogList.Address.AddressDetail}}{{dialogList.Address.ZipCode?' , '+dialogList.Address.ZipCode:''}}</span>
            </li>
          </ul>
          <div class="Items_info_box">
            <div class="Items_info">{{$t('colon.itemsInfo')}}</div>
            <div class="" style="">
              <div class="history_list_title detailPadding">
                <div>{{setTime(dialogList.CreateDate)}}</div>
                <div class="its_Operate">
                  <div class="color_333">{{$t('base.quantity')}}</div>
                  <div class="color_333">{{$t('base.operate')}}</div>
                </div>
              </div>
              <div class="">
                <div class="history_list_box detailPadding" v-for="(item,index) in dialogList.OrderDetails">
                  <div class="like_box">
                    <el-image class="like_img" :src="item.TitImg" fit="contain"></el-image>
                    <div class="like_detail">
                      <p class="line_txt2">{{item.Title}}</p>
                      <span>{{$t('base.arrivedOn')}} {{setTimeS(dialogList.CreateDate)}} <br>{{$t('alert.deliveredTo')}}</span>
                    </div>
                  </div>
                  <div class="its_Operate its_Operate_2">
                    <div class="price_house">
                      <!-- <span>Quantity</span> -->
                      <div class="price_house_list color_333">{{item.QuantitySold}}</div>
                    </div>
                    <div class="history_txt ">
                      <router-link :to="{path:'/mycardhobby/detail/'+item.OrderId}"  target="_blank">{{$t('base.viewDetails')}}</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </el-dialog>
</template>
<script>
import { setUTC, getTime, priceExchange } from "@/api/public";
import qs from 'qs'
export default {
  name: '',
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      dialogList: '',
      dislogType: this.$enumInfo.dislogType,
      dialogBox: 'dialogBoxWarehouse',
      expList: '',
      isData: false,
      isExp: false,
      loading: true,
    }
  },
  filters: {
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    setTimeA(val) {
      return getTime(val, -8, 2, 'cn')
    },
    setTimeS(val) {
      return getTime(val, -8, 1, 'cn')
    },
    setExchange(val) {
      var num = val
      if (num > 0 && num != null) {
        // num = '$ ' + priceExchange(num, 'USD')
        num = '$ ' + num
      } else {
        num = '/'
      }
      //&&item.PayPostageMoney>0 && item.PayPostageMoney!=null ? '$ '+item.PayPostageMoney:'/'
      return num
    }
  },
  props: {
    dom: Boolean,
    item: {}
  },
  watch: {},
  filters: {},
  mounted() {},
  created() {
    this.getOrder(this.item)
  },
  methods: {
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },
    setTimeS(val) {
      return getTime(val, -8, 1, 'cn')
    },
    setTimeSS(val) {
      if (val) {
        val = val.toString().replace(/-/g, "/")
      }
      var time = getTime(val, -8, 0, 'cn')
      return time.indexOf('Invalid') != -1 ? '' : time
    },
    //
    CopyLink(val) {
      let that = this
      this.$copyText(val).then(function(e) {
        that.$message({
          message: that.$t('base.copysuc'),
          type: 'success'
        });
      }, function(e) {
        that.$message.error(that.$t('base.copyerr'));
      })
    },
    // 获取物流信息
    GetExpress(obj,type) {
      let that = this;
      that.exploading = true
      that.isExp = false
      that.expList = '';
      let data = { LogisticCode:obj.Express, ShipperCode: obj.ExpressCode, Mobile: obj.Address.Mobile, OrderCode: obj._id }
      // let data = {
      //   LogisticCode: obj.Express,
      //   ShipperCode: obj.ExpressCode,
      //   Mobile: obj.Address.Mobile,
      //   OrderCode: obj._id
      // }
      if(type=='second'){
        data.ShipperCode=obj.SecondExpressCode
        data.LogisticCode=obj.SecondExpress
      }
      this.$get(this.$interface.GetExpressInfoByShipperCode, data).then(res => {
        if (res.result != 0) {
          if (res.Data == null) {
            that.expList = { Traces: [] }
            that.isData = true
          } else {
            that.expList = res.Data
            if (res.Data.Traces.length > 0) {
              res.Data.ldate = res.Data.Traces[0].AcceptTime
              if (res.Data.State == '3') {
                let leng = res.Data.Traces.length - 1
                res.Data.ndate = res.Data.Traces[leng].AcceptTime
              }
              that.isExp = true
              that.expList = res.Data
            }
          }
        } else {
          that.expList = res.Data
          that.isData = true
        }
        that.exploading = false
        //console.log(res)
      })
    },
    getOrder(obj) {
      let that = this;
      let data = { Id: obj._id }
      this.$get(this.$interface.GetOrderById, data).then(res => {
        if (res.Result != 0) {
          let add = res.Data.Address.AddressDetail
          let add1 = res.Data.Address.AddressDetail
          if (add1.indexOf('()') > 0) {
            // var a=add1.indexOf('()')
            // console.log(add1,a,'add2',add1.substring(0,a))
            //var reg=new RegExp()
            add1 = add1.replace(/\(\)/g, "")
            //console.log(add1,a,'add1')
            res.Data.Address.AddressDetail = add1
          } else {
            add1 = add1.replace(")", "")
            add1 = add1.replace("(", "|")
            add1 = add1.split("|")
            res.Data.Address.AddressDetail = add1[1] && add1[1] != '' ? add1[0] + ' ' + add1[1] : add1[0]
          }
          that.areaSymbol=res.Data.RealOrderPriceUnit
          that.dialogList = res.Data
          if(res.Data.SecondExpressCode){
          that.GetExpress(res.Data,'second')
          }else{
          that.GetExpress(res.Data,'frist')
          }

          that.loading = false
        } else {
          this.$message({
            type: 'error',
            message: res.Msg
          });
          that.loading = false
        }

        // console.log(res)
      })
    },
    DialogClose() {
      this.$root.$emit("warehouse", false);
    },
  },
  destroyed() {
    this.DialogClose()
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/historylist.css";

#dialogBoxWare {
  min-height: 400px;
  max-height: 80vh;
}

.dialogBoxWarehouse .detailPadding {
  margin: 0 20px;
  justify-content: space-between;
}

.detailPadding .like_box {
  width: 50%;
}

.detailPadding .like_detail {
  width: 76%;
  padding-left: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.detailPadding .like_detail>span {
  font-size: 12px;
  color: #a0a0a0;
}

.detailPadding .like_box p {
  padding: 0;
  width: 100%;
}

.detailPadding .price_house {
  width: 150px;
  color: #a0a0a0;
  text-align: center;
}

/* .detailPadding .price_house_list {
  width: 80%;
  margin: 5px auto;
} */
/* 
.detailPadding .price_house_list span {
  width: 50%;
  display: inline-block;
} */
.price_house_list {
  text-align: center;
}

.detailPadding .history_txt {
  width: 150px;
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: auto;
}

.history_txt {
  color: #5f6dae;
}

.Items_info_box {
  overflow: hidden;
}

.Items_info {
  line-height: 24px;
  font-size: 18px;
  margin: 25px 0 25px;
  color: #333;
}

.detailPaddingUL li {
  display: flex;
  margin-bottom: 12px;
}

.detailPaddingUL li:last-child {
  margin: 0 0 25px 0;
}

.detailPaddingUL li span:first-child {
  color: #a0a0a0;
  /* width: 25%; */
  width: 201px;
  margin-right: 18px;
}

.itprice {
  /* width: 195px; */
  width: 112px;
  /* padding-right: 40px; */
}

.tracking {
  width: 116px;
  /* width: 160px; */
}

.overflowY {
  max-height: 350px;
  overflow-y: auto;
}

.its_Operate {
  display: flex;
}

.its_Operate div {
  width: 150px;
  text-align: center;
}

.its_Operate_2 {
  padding-right: 12px;
}

.history_list_title {
  justify-content: space-between;
  padding-left: 12px;

}

/deep/ .el-dialog__body {
  padding: 13px 20px 8px;
}

.history_list_title>div {
  padding: 0;
}

.history_txt.text_gray:hover,
.history_txt.text_gray {
  color: #a0a0a0;
  text-decoration: none;
  cursor: no-drop;
}

.detail_steps {
  width: 99%;
  height: 270px;
}

.steps_list {
  width: 425px;
  position: relative;
}

.steps_list.error {
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  font-size: 18px;
}

.steps_list_up {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 42px;
}

.steps_list_up .time {
  width: 85px;
}

.steps_list_up .add {
  width: 295px;
  align-items: center;
  display: flex;
  word-break: break-all;
}

.steps_list_up .dott {
  width: 24px;
  background: url(../../../static/images/icon/icon_finish_on.svg) no-repeat center;
  min-height: 30px;
  background-size: contain;
  margin-top: 0;
}

.steps_line {
  border-left: 1px solid #a0a0a0;
  padding-bottom: 28px;
  position: absolute;
  bottom: 0;
  height: 28px;
  left: 107px;
}

.steps_list:last-child .steps_line {
  display: none
}

.dialogBoxWarehouse .dialogData {
  padding-bottom: 25px;
}

/deep/ .el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
}

/deep/ .is-horizontal {
  display: none;
}

.qwq {
  width: 55%;
  margin: 0 auto;
}

.more {
  font-size: 16px;
  color: #A0A0A0;
  cursor: pointer;
  margin: 10px auto;
  display: block;
  width: 100px;
  text-align: center;
}
.copy{
  cursor: pointer;
}
.copy:hover{
  color: #5F6DAE;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/warehouse.vue